import { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { RequestMaker } from "../../online-artifacts";
interface Lead {
	name: string;
	email: string;
	phone: string;
	lang: string;
	real: boolean;
	country: string;
}

interface ConfigurationLead {
	real: boolean;
	describe_farm: any;
	fields: any[];
	personnels: any[];
	inventory_items: any[];
	machineries: any[];
}

interface Credential {
	password: string;
	generate: boolean;
}

interface UTMData {
	utm_campaign: string;
	utm_source: string;
	utm_medium: string;
	utm_term: string;
	utm_content: string;
}

const apiLayer = () => {
	const [requestMaker] = useState<RequestMaker>(new RequestMaker('https://www.agrapp.cl'));
	const [leadId, setLeadId] = useState<number>(undefined);
	const [utmData, setUtmData] = useState<UTMData>({
		utm_campaign: '',
		utm_source: '',
		utm_medium: '',
		utm_term: '',
		utm_content: '',
	});

	useEffect(() => {
		
	}, [])

	const getCropsTypes = async () => {
		try {
			const { data } = await requestMaker.get('/api/v2/onboarding/crop_types');
			const { crop_types } = data;
			const crops = crop_types.data;
			const cropsMap = new Map();
			for (let index = 0; index < crops.length; index++) {
				const element = crops[index];
				if (!cropsMap.has(element.name)) {
					cropsMap.set(element.name, element);
				}
			}
			const filteredCrops = Array.from(cropsMap.values());
			data.crop_types.data = filteredCrops;
			return data;
		} catch (error) {
			throw error;
		}
	};

	const validateEmail = async (email: string) => {
		try {
			const { data } = await requestMaker.post('/api/v2/onboarding/leads/validate_email', {
				email: email
			});
			if (!data.isValid) {
				const mailError = new Error('Current email is taken');
				mailError.name = "TakenMail";
				throw mailError;
			}
		} catch (error) {
			throw error;
		}
	};

	const createLead = async (contactInformation: Lead) => {
		const expandedLead = {...contactInformation, ...utmData};
		try {
			const { data } = await requestMaker.post('/api/v2/onboarding/steps/create_lead', {
				lead: expandedLead
			});
			return data;
		} catch (error) {
			throw error;
		}
	};

	const configurationLead = async (configurationLead: ConfigurationLead) => {
		const expandedConfigurationLead = {...configurationLead, ...utmData};
		try {
			if (!leadId) {
				throw new Error('Lead id is undefined');
			}
			const { data } = await requestMaker.patch(`/api/v2/onboarding/steps/${leadId}/configuration`, {
				lead: expandedConfigurationLead
			});
			return data;
		} catch (error) {
			throw error;
		}
	};

	const activatePassword = async (credential: Credential) => {
		const expandedCredential = {...credential,...utmData};
		try {
			if (!leadId) {
				throw new Error('Lead id is undefined');
			}
			const { data } = await requestMaker.patch(`/api/v2/onboarding/steps/${leadId}/activate_password`, {
				lead: expandedCredential
			});
			return data;
		} catch (error) {
			throw error;
		}
	};

	const welcome = async () => {
		try {
			if (!leadId) {
				throw new Error('Lead id is undefined');
			}
			const { data } = await requestMaker.patch(`/api/v2/onboarding/steps/${leadId}/welcome`, {...utmData});
			return data;
		} catch (error) {
			throw error;
		}
	};

	const getLocationThroughIP = async () => {
		try {
			const { data } = await requestMaker.get('/api/v2/connexions/location');
			return data;
		} catch (error) {
			throw error
		}
	};

	return {
		requestMaker,
		leadId,
		utmData,
		setLeadId,
		createLead,
		configurationLead,
		activatePassword,
		welcome,
		validateEmail,
		getCropsTypes,
		getLocationThroughIP,
		setUtmData,
	};
};


export const ApiContainer = createContainer(apiLayer);
